import { YearPickerInput } from '@mantine/dates';

const CustomYearPicker = (props: any) => {

  return (
    <YearPickerInput
      withAsterisk={props.required}
      clearable={true}
      {...props}
    />
  )
};

export default CustomYearPicker;